#import "../fragments/external-meeting-fragment.graphql"

mutation AssociateExternalMeetingWithActivity($input: ExternalMeetingAssociateWithActivityInput!) {
    externalMeetingAssociateWithActivity(input: $input) {
        ...ExternalMeetingFragment
    }
}
